import styled from 'styled-components';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';

export const DropdownMenu = styled(DropdownMenuPrimitive.Root)``;
export const DropdownMenuTrigger = styled(DropdownMenuPrimitive.Trigger)`
    background: transparent;
    margin-left: 30px;
    border: none;
    display: flex;
    :focus-visible {
        outline: none;
    }
`;

export const StyledItem = styled(DropdownMenuPrimitive.Item)`
    display: flex;
    padding: 3px 10px;
    :hover{
        background-color: ${(props) => props.theme.colors.textSubtle};
        color: ${(props) => props.theme.colors.text};
        cursor: pointer;
    }
`;

export const StyledContent = styled(DropdownMenuPrimitive.DropdownMenuContent)`
    min-width: 220px;
    background-color: ${(props) => props.theme.colors.text};
    border-radius: 5px;
`;

export const StyledSeparator = styled(DropdownMenuPrimitive.Separator)`
    height: 1px;
    background-color: ${(props) => props.theme.colors.primary};
    margin: 5px;
`;

export const RightSlot = styled.div`
    margin-left: auto;
    color: ${(props) => props.theme.colors.primary};
`;